/**
 * @file Leader List.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Leader List component.
 */
const vLeaderList = () => {
	const leaderList = document.querySelector('.v-leader-list');

	if (!leaderList) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);
	const leaderListBg = leaderList.querySelector('.v-leader-list__bg-transition');
	gsap.set(leaderListBg, { scaleX: 0 });

	ScrollTrigger.matchMedia({
		'(min-width: 1025px)': () => {
			gsap.timeline({
				defaults: {
					ease: 'sine.out',
				},
				scrollTrigger: {
					trigger: leaderListBg,
					start:   '90% bottom',
					end:     'center center',
					scrub:   true,
				},
			})
				.to(leaderListBg, {
					opacity: 1,
				})
				.to(leaderListBg, {
					scaleX: 1,
				}, '<');
		},
	});
};

export default vLeaderList;
